import { isThirdPartyIntegrations } from 'app/policies/config';
import { USER_ROLES } from 'app/services/users.service';

const ADMINISTRATIVE_ROLES = new Set([USER_ROLES.admin, USER_ROLES.helpDesk, USER_ROLES.adminFixedLayout]);

function canPermissions(user) {
  return ADMINISTRATIVE_ROLES.has(user?.role_guid);
}

export function permissionsRol(user) {
  const canManageUsers = canPermissions(user);
  const canManageThirdPartyUsers = canManageUsers && !isThirdPartyIntegrations(user);

  return {
    readList: canManageUsers,
    readDetail: canManageUsers,
    create: canManageUsers,
    update: canManageUsers,
    delete: canManageUsers,

    // TABLE USERS:
    columnAdminSchool: canManageThirdPartyUsers,

    // DETAIL USER:
    tabPassword: canManageUsers,
    tabLicenses: canManageThirdPartyUsers,
    tabAdminSchool: canManageThirdPartyUsers,
    showUploadAvatar: canManageThirdPartyUsers,
    submitDetail: canManageUsers,
    updateDetail: canManageThirdPartyUsers,
  };
}
